import { Box, Stack, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const OrderDetailsRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('spacing-24-16'),
  width: '100%',
  padding: uni('padding-content'),
  borderRadius: uni('border-radius-md'),
  border: `1px solid ${uni('border-static-content-default')}`,
  backgroundColor: uni('bg-static-content-default'),

  [tabletBreakpoint]: {
    borderRadius: uni('border-radius-sm'),
  },
}));

export const OrderDetailsHeading = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  gap: uni('scale-200'),

  [tabletBreakpoint]: {
    flexDirection: 'column',
    gap: uni('scale-100'),
  },
}));

export const OrderDetailsTitle = styled('p')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
`;

export const OrderDetailsCode = styled('p')`
  ${uniTypography('text-lg', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};
  margin: 0;
`;

export const OrderDetailsColumns = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: uni('scale-1000'),
  width: '100%',

  [tabletBreakpoint]: {
    flexDirection: 'column',
    gap: uni('scale-400'),
  },
}));

export const OrderDetailsColumnRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  flex: '1 0 0',
  minWidth: 0,
  width: '100%',
}));

export const OrderDetailsFieldRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-100'),
  minWidth: 0,
}));

export const OrderDetailsFieldLabel = styled('p')`
  ${uniTypography('text-md', 'bold')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const OrderDetailsFieldValueRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: uni('scale-100'),
  minWidth: 0,
  color: uni('fg-neutral-static-default-body'),
}));

export const OrderDetailsFieldValueText = styled('p')`
  ${uniTypography('text-md', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
